import Vue from 'vue'
import Vuex from 'vuex'

// Make vue aware of Vuex
Vue.use(Vuex)

// Create an object to hold the initial state when
// the app starts up
const state = {
  error: {
    show: false,
    message: ''
  },
  current_championship: false,
  current_date: false,
  current_course: false,
  current_player: false,
  loading: false,
  registrations: [],
  current_card: {
    id: null,
    registration_id: null,
    date_id: null,
    h1: null,
    h2: null,
    h3: null,
    h4: null,
    h5: null,
    h6: null,
    h7: null,
    h8: null,
    h9: null,
    h10: null,
    h11: null,
    h12: null,
    h13: null,
    h14: null,
    h15: null,
    h16: null,
    h17: null,
    h18: null
  },
  card_saved: false,
  holes_in: [],
  holes_out: [],
  players_waiting: [],
  players_ready: [],
  player_cards: [],
  show_player_cards: false,
  show_player: false,
  show_card: false,
  configuration: {
    category: false,
    categories: [],
    dates: [],
    courses: [],
    player: false,
    championship: false,
    registrations: [],
    teams: [],
    team: {
      id: null,
      name: null,
      championship_id: null
    },
    awards: [],
    award: {
      id: null,
      name: null,
      slug: null,
      class: null
    }
  }
}

// Create an object storing various mutations. We will write the mutation
const mutations = {
  SET_ERROR (state, value) {
    state.error = value
  },
  SET_CHAMPIONSHIP (state, value) {
    state.current_championship = value
  },
  SET_DATE (state, value) {
    state.current_date = value
  },
  SET_COURSE (state, value) {
    state.current_course = value
  },
  SET_PLAYER (state, value) {
    state.current_player = value
  },
  SET_LOADING (state, value) {
    state.loading = value
  },
  SET_REGISTRATIONS (state, value) {
    state.registrations = value
  },
  SET_CARD (state, value) {
    state.current_card = value
  },
  SET_HOLES_IN (state, value) {
    state.holes_in = value
  },
  SET_HOLES_OUT (state, value) {
    state.holes_out = value
  },
  SET_PLAYERS_WAITING (state, value) {
    state.players_waiting = value
  },
  SET_PLAYERS_READY (state, value) {
    state.players_ready = value
  },
  SET_CARD_SAVED (state, value) {
    state.card_saved = value
  },
  SET_PLAYER_CARDS (state, value) {
    state.player_cards = value
  },
  SET_SHOW_PLAYER_CARDS (state, value) {
    state.show_player_cards = value
  },
  SET_SHOW_PLAYER (state, value) {
    state.show_player = value
  },
  SET_SHOW_CARD (state, value) {
    state.show_card = value
  },
  SET_CONFIG_CATEGORIES (state, value) {
    state.configuration.categories = value
  },
  SET_CONFIG_CATEGORY (state, value) {
    state.configuration.category = value
  },
  SET_CONFIG_DATES (state, value) {
    state.configuration.dates = value
  },
  SET_CONFIG_PLAYER (state, value) {
    state.configuration.player = value
  },
  SET_CONFIG_CHAMPIONSHIP (state, value) {
    state.configuration.championship = value
  },
  SET_CONFIG_COURSES (state, value) {
    state.configuration.courses = value
  },
  SET_CONFIG_REGISTRATIONS (state, value) {
    state.configuration.registrations = value
  },
  SET_CONFIG_TEAMS (state, value) {
    state.configuration.teams = value
  },
  SET_CONFIG_TEAM (state, value) {
    state.configuration.team = value
  },
  SET_CONFIG_AWARDS (state, value) {
    state.configuration.awards = value
  },
  SET_CONFIG_AWARD (state, value) {
    state.configuration.award = value
  }
}

// Combine the initial state and the mutations to create a Vuex store.
// This store can be linked to our app.
export default new Vuex.Store({
  state,
  mutations
})



/** WEBPACK FOOTER **
 ** ./src/vuex/store.js
 **/